import { render, staticRenderFns } from "./RemoveFilterButton.vue?vue&type=template&id=56ef2ec8"
import script from "./RemoveFilterButton.vue?vue&type=script&lang=js"
export * from "./RemoveFilterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports